import { h, Fragment } from 'preact'
import PayPalLogo from '../../../assets/icons/PayPal_logo.svg'
import IDealLogo from '../../../assets/icons/ideal-wero.svg'
import DirectDebitLogo from '../../../assets/icons/Direct-debit-logo.svg'
import PayPalCreditLogo from '../../../assets/icons/PayPal-Credit-logo.svg'
import ApplePayLogo from '../../../assets/icons/ApplePay_logo.svg'
import TrustlyLogo from '../../../assets/icons/trustly-green-logo.svg'
import VippsLogo from '../../../assets/icons/logos-payment-vipps.svg'
import GooglePayLogo from '../../../assets/icons/google-pay-mark_800.svg'
import BancontactLogo from '../../../assets/icons/Bancontact-Horizontal-logo-RGB.svg'
import WalleyLogo from '../../../assets/icons/walley-logo.svg'
import MobilePayLogo from '../../../assets/icons/mobile-pay-icon.svg'
import SwishLogo from '../../../assets/icons/swish-icon.svg'
import { PAYMENT_METHOD_TYPES } from '../../../constants/paymentMethods'
import ShowMore from '../../../components/Common/ShowMore'
import { CheckmarkIcon, ExternalLinkIcon } from '../../../assets/dynamicIcons'

export const paymentMethodsMap = new Map([
  [
    PAYMENT_METHOD_TYPES.Card,
    {
      name: PAYMENT_METHOD_TYPES.Card,
      logo: null,
      subLogo: () => {},
      title: 'Card payment',
      isIOSRequired: false,
      isGooglePaySupportRequired: false,
      content: () => {},
    },
  ],
  [
    PAYMENT_METHOD_TYPES.PayPalCredit,
    {
      name: PAYMENT_METHOD_TYPES.PayPalCredit,
      logo: PayPalCreditLogo,
      subLogo: () => {},
      title: 'PayPal credit',
      isIOSRequired: false,
      isGooglePaySupportRequired: false,
      showTotalPrice: true,
      content: () => {},
    },
  ],
  [
    PAYMENT_METHOD_TYPES.ApplePay,
    {
      name: PAYMENT_METHOD_TYPES.ApplePay,
      title: 'Apple Pay',
      logo: ApplePayLogo,
      subLogo: () => {},
      isIOSRequired: true,
      isGooglePaySupportRequired: false,
      content: () => {},
    },
  ],
  [
    PAYMENT_METHOD_TYPES.GooglePay,
    {
      name: PAYMENT_METHOD_TYPES.GooglePay,
      title: 'Google Pay',
      logo: GooglePayLogo,
      className: 'google-pay-method',
      subLogo: () => {},
      isIOSRequired: false,
      isGooglePaySupportRequired: true,
      content: () => {},
    },
  ],
  [
    PAYMENT_METHOD_TYPES.DirectDebit,
    {
      name: PAYMENT_METHOD_TYPES.DirectDebit,
      logo: DirectDebitLogo,
      showTotalPrice: true,
      subLogo: () => {},

      title: 'Direct Debit',
      isIOSRequired: false,
      isGooglePaySupportRequired: false,
      content: () => {},
    },
  ],
  [
    PAYMENT_METHOD_TYPES.PayPal,
    {
      name: PAYMENT_METHOD_TYPES.PayPal,
      logo: PayPalLogo,
      subLogo: () => {},
      title: 'PayPal',
      isIOSRequired: false,
      isGooglePaySupportRequired: false,
      content: () => {},
    },
  ],
  [
    PAYMENT_METHOD_TYPES.IDeal,
    {
      name: PAYMENT_METHOD_TYPES.IDeal,
      logo: IDealLogo,
      className: 'ideal-method',
      subLogo: () => {},
      title: 'IDeal',
      isIOSRequired: false,
      isGooglePaySupportRequired: false,
      content: () => {},
    },
  ],
  [
    PAYMENT_METHOD_TYPES.Bancontact,
    {
      name: PAYMENT_METHOD_TYPES.Bancontact,
      logo: BancontactLogo,
      className: 'bancontact-method',
      subLogo: () => {},
      title: 'Bancontact',
      isIOSRequired: false,
      isGooglePaySupportRequired: false,
      content: () => {},
    },
  ],
  [
    PAYMENT_METHOD_TYPES.Trustly,
    {
      name: PAYMENT_METHOD_TYPES.Trustly,
      logo: TrustlyLogo,
      className: 'trustly-method',
      subLogo: () => {},
      title: 'Trustly',
      isIOSRequired: false,
      isGooglePaySupportRequired: false,
      content: () => {},
    },
  ],
  [
    PAYMENT_METHOD_TYPES.Vipps,
    {
      name: PAYMENT_METHOD_TYPES.Vipps,
      logo: VippsLogo,
      className: 'vipps-method',
      subLogo: () => {},
      title: 'Vipps',
      isIOSRequired: false,
      isGooglePaySupportRequired: false,
      content: () => {},
    },
  ],
  [
    PAYMENT_METHOD_TYPES.Walley,
    {
      name: PAYMENT_METHOD_TYPES.Walley,
      logo: WalleyLogo,
      className: 'walley-method',
      subLogo: () => {},
      title: 'Walley',
      isIOSRequired: false,
      isGooglePaySupportRequired: false,
      content: () => {},
    },
  ],
  [
    PAYMENT_METHOD_TYPES.MobilePay,
    {
      name: PAYMENT_METHOD_TYPES.MobilePay,
      logo: MobilePayLogo,
      className: 'mobile-pay-method',
      subLogo: () => {},
      title: 'MobilePay',
      isIOSRequired: false,
      isGooglePaySupportRequired: false,
      content: () => {},
    },
  ],
  [
    PAYMENT_METHOD_TYPES.Swish,
    {
      name: PAYMENT_METHOD_TYPES.Swish,
      logo: SwishLogo,
      className: 'swish-method',
      subLogo: () => {},
      title: 'Swish',
      isIOSRequired: false,
      isGooglePaySupportRequired: false,
      content: () => {},
    },
  ],
])

export const desktopSort = [
  PAYMENT_METHOD_TYPES.ApplePay,
  PAYMENT_METHOD_TYPES.DirectDebit,
  PAYMENT_METHOD_TYPES.PayPalCredit,
  PAYMENT_METHOD_TYPES.IDeal,
  PAYMENT_METHOD_TYPES.Card,
  PAYMENT_METHOD_TYPES.Bancontact,
  PAYMENT_METHOD_TYPES.PayPal,
  PAYMENT_METHOD_TYPES.Trustly,
  PAYMENT_METHOD_TYPES.Vipps,
  PAYMENT_METHOD_TYPES.Walley,
  PAYMENT_METHOD_TYPES.MobilePay,
  PAYMENT_METHOD_TYPES.Swish,
]

export const mobileSort = [
  PAYMENT_METHOD_TYPES.ApplePay,
  PAYMENT_METHOD_TYPES.PayPalCredit,
  PAYMENT_METHOD_TYPES.IDeal,
  PAYMENT_METHOD_TYPES.DirectDebit,
  PAYMENT_METHOD_TYPES.PayPal,
  PAYMENT_METHOD_TYPES.Card,
  PAYMENT_METHOD_TYPES.Bancontact,
  PAYMENT_METHOD_TYPES.Trustly,
  PAYMENT_METHOD_TYPES.Vipps,
  PAYMENT_METHOD_TYPES.Walley,
  PAYMENT_METHOD_TYPES.MobilePay,
  PAYMENT_METHOD_TYPES.Swish,
]
